// <s-story-media> plays a muted clip only when it is needed: while on screen (ambient)
// or while hovered / centred on touch screens (hover). Reduced motion keeps the still.
class SStoryMedia extends HTMLElement {
  #ac;
  #observer;
  #video;

  connectedCallback() {
    this.#video = this.querySelector('video');
    if (!this.#video) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const mode = this.dataset.mode || 'hover';
    const canHover = window.matchMedia('(hover: hover)').matches;

    if (mode === 'hover' && canHover) {
      const card = this.closest('[data-story-card]') || this;
      card.addEventListener('pointerenter', () => this.#play(), opts);
      card.addEventListener('focusin', () => this.#play(), opts);
      card.addEventListener('pointerleave', () => this.#stop(true), opts);
      card.addEventListener('focusout', () => this.#stop(true), opts);
      return;
    }

    const rootMargin = mode === 'ambient' ? '0px' : '-35% 0px -35% 0px';
    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) this.#play();
          else this.#stop(false);
        }
      },
      { rootMargin }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#observer?.disconnect();
  }

  #play() {
    const video = this.#video;
    const attempt = video.play();
    if (attempt && typeof attempt.then === 'function') {
      attempt.then(() => video.setAttribute('data-playing', '')).catch(() => {});
    } else {
      video.setAttribute('data-playing', '');
    }
  }

  #stop(reset) {
    const video = this.#video;
    video.pause();
    video.removeAttribute('data-playing');
    if (reset) video.currentTime = 0;
  }
}

if (!customElements.get('s-story-media')) customElements.define('s-story-media', SStoryMedia);
